import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useAdminStore } from '@getmayday/vue-modules';
import { Pinia } from 'pinia';

export default (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const pinia = inject('pinia') as Pinia;
  const adminStore = useAdminStore(pinia);

  const authorizedSession = !!adminStore.accessToken;
  if (
    to.matched.some((record) => record.meta.authorize) &&
    !authorizedSession
  ) {
    return next({ name: 'login' });
  }

  next();
};
